<template>
  <div class="relative">
    <NuxtImg 
      :src="toImgixPath(url)"
      loading="lazy"
      provider="imgix" 
      format="webp"
      width="390"
      height="390"
      :fit="fit" 
      :sizes="sizes" 
      :modifiers="modifiers" 
      :alt="altText"
      class="w-full" />
      <div class="slot absolute bottom-3 left-3 inline">
        <slot/>
      </div>
  </div>
  </template>
  
  
  <script setup>
  const {toImgixPath} = useImageUtils();
  const props = defineProps({
    url: {
      type: String,
      required: true
    },
    altText: {
      type: String,
      default: 'Gravaa Image'
    },
    title: {
      type: String,
      default: 'Gravaa Image'
    },
    fit:{
        type: String,
        default: 'crop'
    },
    sizes: {
        type: String,
        default: 'sm:400px md:400px lg:1000px xl:1000px'
    },
    modifiers: {
        type: Object,
        default: () => ({
        auto: 'format,compress',
        fit: 'crop',
        crop: 'faces,edges',
        ar: '1:1'
        })
    }
  });
  

  </script>
  
  <style scoped>
  /* Din CSS här */
  </style>